<template>
  <div class="table-header-cell">
    <span
      class="table-header-label"
      :class="{ 'table-header-label--sortable': sortable }"
      @click="onSortClicked"
    >
      {{ text }}

      <v-icon
        v-if="sortable"
        small
        color="white"
      >
        {{ isSortedDesc ? "mdi-arrow-down" : "mdi-arrow-up" }}
      </v-icon>

      <v-icon
        v-if="dataIcon"
        small
        :color="dataIconColor"
        class="data-source-icon"
        :title="dataIconTitle"
      >
        {{ dataIcon }}
      </v-icon>
    </span>

    <v-menu
      v-if="filterOptions.length"
      offset-y
    >
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          v-bind="attrs"
          small
          color="white"
          class="filter-menu-icon"
          v-on="on"
        >
          mdi-menu-down
        </v-icon>
      </template>

      <v-list dense>
        <v-list-item
          v-for="option in normalizedFilterOptions"
          :key="option"
          @click="$emit('filter-change', option)"
        >
          <v-list-item-title class="filter-menu-item">
            {{ option }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: "TableHeaderCell",

  props: {
    text: {
      type: String,
      default: "",
    },

    value: {
      type: String,
      default: "",
    },

    sortable: {
      type: Boolean,
      default: false,
    },

    isSortedDesc: {
      type: Boolean,
      default: false,
    },

    filterOptions: {
      type: Array,
      default: () => [],
    },

    dataIcon: {
      type: String,
      default: "",
    },

    dataIconColor: {
      type: String,
      default: "",
    },

    dataIconTitle: {
      type: String,
      default: "",
    },
  },

  computed: {
    normalizedFilterOptions() {
      return ["All", ...this.filterOptions];
    },
  },

  methods: {
    onSortClicked() {
      if (!this.sortable) return;
      this.$emit("sort-change", this.value);
    },
  },
};
</script>

<style scoped>
.table-header-cell {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.table-header-label {
  font-weight: 600;
  font-size: 12px;
  user-select: none;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 6px;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 0.05);
  white-space: nowrap;
}

.table-header-label--sortable {
  cursor: pointer;
}

.data-source-icon {
  margin-left: 4px;
}

.filter-menu-icon {
  cursor: pointer;
}

.filter-menu-item {
  font-size: 12px;
}
</style>
